<template>
  <div class="content_box">
    <el-button type="primary" size="mini" class="handleOpen" @click="handleOpen">新窗口预览</el-button>
    <iframe :src="iframe" width="1100px" height="630px" class="iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: "dashboard",
  created() {},
  watch: {},
  data() {
    return {
      iframe: "http://chart.bboycc.cn/#/chart/preview/30",
      show: false,
      message: ""
    };
  },
  methods: {
    async handleOpen() {
      window.open(this.iframe, "_blank");
    }
  }
};
</script>
<style scoped>
.content_box {
  height: 100%;
  width: 100%;
  background: #000000;
  /* border: 1px solid rgb(0, 0, 0); */
}
.handleOpen {
  margin: 20px;
}
.iframe {
  display: block;
  margin: 0 auto;
  border-radius: 10px;
}
</style>